<template>
  <div style="background-color: white;">
    <v-divider />
    <v-layout class="py-1" style="align-items: center;">
      <v-spacer />
      <div class="caption secondary--text mr-3">
        {{ currentPage }}
        <span v-if="value && value.total">
          of {{ value.total }}
        </span>
      </div>
      <v-btn class="ml-3" :disabled="!canPrevious" @click="previous()" icon>
        <v-icon color="">chevron_left</v-icon>
      </v-btn>
      <v-btn :disabled="!canNext" @click="next()" icon>
        <v-icon color="">chevron_right</v-icon>
      </v-btn>
    </v-layout>
    <v-divider />
  </div>
</template>

<script>
  export default {
    props: {
      value: Object,
    },
    data: () => ({}),
    computed: {
      currentPage() {
        if (!this.value || this.value.page === null) return '-'
        return `${ this.from(this.value.page, this.value.size) + 1 }-${ this.to(this.value.page, this.value.size, this.value.total) }`
      },
      canNext() {
        return this.to(this.value.page, this.value.size) < this.value.total
      },
      canPrevious() {
        return this.value.page > 0
      },
    },
    methods: {
      next() {
        if (this.canNext) {
          let page = this.value.page + 1
          this.update({
            page,
            from: this.from(page, this.value.size),
          })
        }
      },
      previous() {
        if (this.canPrevious) {
          let page = this.value.page - 1
          this.update({
            page,
            from: this.from(page, this.value.size),
          })
        }
      },
      update(value) {
        this.$emit('input', {
          ...this.value,
          ...value,
        })
      },
      from: (page, size) => (page * size),
      to: (page, size, total) => total <= size * (page + 1) ? total : size * (page + 1),
    },
  }
</script>